/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_GeneratingInputs */

const en_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating...`)
};

const de_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird generiert...`)
};

const fr_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération en cours...`)
};

const es_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando...`)
};

const it_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione...`)
};

const nl_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereren...`)
};

const pl_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generowanie...`)
};

const fi_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luodaan...`)
};

const da_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererer...`)
};

const sv_salary_negotiate_generating = /** @type {(inputs: Salary_Negotiate_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererar...`)
};

/**
* | output |
* | --- |
* | "Generating..." |
*
* @param {Salary_Negotiate_GeneratingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_generating = /** @type {((inputs?: Salary_Negotiate_GeneratingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_GeneratingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_generating(inputs)
	if (locale === "fr") return fr_salary_negotiate_generating(inputs)
	if (locale === "es") return es_salary_negotiate_generating(inputs)
	if (locale === "it") return it_salary_negotiate_generating(inputs)
	if (locale === "nl") return nl_salary_negotiate_generating(inputs)
	if (locale === "pl") return pl_salary_negotiate_generating(inputs)
	if (locale === "fi") return fi_salary_negotiate_generating(inputs)
	if (locale === "da") return da_salary_negotiate_generating(inputs)
	if (locale === "sv") return sv_salary_negotiate_generating(inputs)
	return en_salary_negotiate_generating(inputs)
});